import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "..";
import PublicCongress from "../../dtos/congress";
import CongressApi from "../../api/congress";

class CongressServiceReader extends ServiceReader {
  public async all(): Promise<PublicCongress[]> {
    return await new CongressApi().get();
  }
}
class CongressServiceCreator extends ServiceCreator {}
class CongressServiceUpdater extends ServiceUpdater {}
class CongressServiceDeleter extends ServiceDeleter {}

export default class CongressService extends Service {
  public get read(): CongressServiceReader {
    return new CongressServiceReader();
  }
  public get create(): CongressServiceCreator {
    return new CongressServiceCreator();
  }
  public get update(): CongressServiceUpdater {
    return new CongressServiceUpdater();
  }
  public get delete(): CongressServiceDeleter {
    return new CongressServiceDeleter();
  }
}
